<svg width="120" height="121" viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M106 14.5H14V86.5H39.5462L34.2262 105.5H44.6109L49.9309 86.5H70.0691L75.3891 105.5H85.7738L80.4538 86.5H106V14.5ZM65 30.5V70.5H55V30.5H65ZM85 45.5V70.5H75V45.5H85ZM45 55.5V70.5H35V55.5H45Z"
    fill="#E8E8E8"
  />
</svg>
